module.exports = __webpack_public_path__ + "static/media/adventureHeroImage.0953dc1c.png";